import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import ListHeader from '../../components/list/ListHeader';
import MassUpdatePopup from '../../components/list/MassUpdatePopup';
import TableUI from '../../components/list/TableUI';
import FilterPannel from '../../components/filter/FilterPannel';
import HeaderViewList from '../list/HeaderViewList';
import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import ProjectAPI from '../../api/ProjectAPI';
import Util from '../../util/Util';
import KeyValueAPI from '../../api/KeyValueAPI';
import Display from '../../util/Display';
import ImportExportAPI from '../../api/ImportExportAPI';
import ViewController from '../../controller/ViewController';

class ProjectList extends React.Component {

  constructor(props) {
    super(props);

    const query = new URLSearchParams(props.location.search);
    let filters = query.get('filters') ? JSON.parse(query.get('filters')) : null;

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.project;

    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    this.views = ViewController.getViews(Const.Project);
    this.view = this.views.find((view) => view.id === (filters ? 0 : cView.project ? cView.project : 0));
    if(!this.view) {
      this.view = this.views.find(view => view.type === 0);
    }
    
    if(!filters) {
      const list = reactLocalStorage.getObject(Const.ListProject);
      filters = list && list.filters ? list.filters : filters;
    }
    this.setList(filters);
    
    this.data = { projects: [], projectCount: 0 };
    this.state = { massUpdate: false, inApiCall: true, isFilterOpen: this.list.isFilterOpen };

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
    this.selected = [];
  }

  componentDidMount() { if(this.List) this.loadProjects(); }

  setList = filters => {
    let modelfields = reactLocalStorage.getObject(Const.FieldList);
    let lists = modelfields.project;
    if (!lists) {
      lists = [];
      modelfields = { ...modelfields, project: lists };
    }

    const fields = ['project_name', 'developer_name', 'responsible_person'];
    this.list = lists.find(list => list.view === this.view.id);

    if (!this.list) {
      this.list = { view: this.view.id };
      modelfields = { ...modelfields, project: [...modelfields.project, this.list] };
    }

    this.list.fields = this.view.fields && this.view.fields.length > 0 && this.view.fields[0] ? this.view.fields 
      : this.list.fields ? this.list.fields : fields;
    this.list.filters = filters ? filters : this.list.filters ? this.list.filters : [];

    this.list.pagination = this.list.pagination ? this.list.pagination : {};
    this.list.pagination.currentPage = this.list.pagination.currentPage ? this.list.pagination.currentPage : 1;
    this.list.pagination.pageCount = this.list.pagination.pageCount ? this.list.pagination.currentPage : 1;
    this.list.pagination.perPage = this.list.pagination.perPage ? this.list.pagination.perPage : 10;

    this.list.sorting = this.list.sorting ? this.list.sorting : { };
    this.list.sorting.field = this.view.sortField ? this.view.sortField : 'id';
    this.list.sorting.order = this.view.sortOrder ? this.view.sortOrder : -1; 

    if(this.ListRestrict) {
      this.list.fields = this.view && this.view.fields && this.view.fields.length > 0 ?  this.view.fields : fields;
    }

    this.list.fields = this.list.fields.filter((field) => {
      if(!field) {
        return false;
      }
      
      if (field.includes(Const.Opt))
        return (
          this.model.fields[field.split(Const.Opt)[0]] &&
          this.model.fields[field.split(Const.Opt)[0]].visible === Const.True
        );
      else
        return (
          this.model.fields[field] &&
          this.model.fields[field].visible === Const.True
        );
    });

    reactLocalStorage.setObject(Const.FieldList, modelfields);
  }

  saveListFilters = filters => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.project.find((item) => item.view === this.view.id);
    tmp.filters = filters;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
  }

  saveListFields = fields => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.project.find((item) => item.view === this.view.id);
    tmp.fields = fields;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => {});
  }

  savePageChange = currentPage => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.project.find((item) => item.view === this.view.id);
    tmp.pagination.currentPage = currentPage;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
  }

  loadProjects = () => {
    const restrict = this.list.filters.find(filter => filter.field === 'responsible_person');
    if(this.Restrict && !restrict) {
      this.list.filters.push({field: 'responsible_person', type: 'multiselect~user',
        condition: 'equals', value: this.User});
    }
    
    this.setState({ ...this.state, inApiCall: true });
    reactLocalStorage.setObject(Const.ListProject, this.list);
    ProjectAPI.list(this.list, this.onReceived, this.onFail);
  }

  onReceived = res => {
    this.data.projects = res.data;
    this.data.projectCount = res.count;
    this.list.pagination.pageCount = Math.ceil(res.count / this.list.pagination.perPage);
    this.setState({ ...this.state, inApiCall: false });
  }
  onFail = res => this.setState({ ...this.state, inApiCall: false });

  savePerPage = perPage => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.project.find((item) => item.view === this.view.id);
    tmp.pagination.perPage = perPage;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => {});
  }

  onPageChange = currentPage => {
    this.list.pagination.currentPage = currentPage;
    this.savePageChange(currentPage);
    this.loadProjects();
  }

  onPerPageChange = perPage => {
    this.list.pagination.perPage = perPage;
    this.savePerPage(perPage);
    this.loadProjects();
  }

  onFieldSelection = fields => {
    this.list.fields = fields;
    this.saveListFields(fields);
    this.loadProjects();
  }

  onOrderChange = (field, order) => {
    this.list.sorting = { field, order };
    reactLocalStorage.setObject(Const.ListProject, this.list);
    this.saveListSort(this.list.sorting);
    this.loadProjects();
  }

  showMassUpdate = () => this.setState({ ...this.state, massUpdate: !this.state.massUpdate });

  hideMassUpdate = () => this.setState({ ...this.state, massUpdate: false });

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    reactLocalStorage.setObject(Const.ListProject, this.list);
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  }
  closeFilter = () => this.setState({ ...this.state, isFilterOpen: false });
  onFilterChange = filters => { this.list.filters = filters; this.loadProjects(); }

  onAddEdit = indx => this.props.navigate(`${this.props.match.path}/add-edit/`
    + `${indx !== -1 ? this.data.projects[indx].id : 0}`);
  onPreview = indx => this.props.navigate(`${this.props.match.path}/preview/`
    + `${this.data.projects[indx].id}`);
  onDelete = indx => Util.confirmAlert('Delete', `Are you sure you want to delete to`
    + ` ${Display.ModelName(this.data.projects[indx])}`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      ProjectAPI.delete(this.data.projects[indx].id, this.onDeleteSuccess,
        this.props.failure, this.props.logout);
  });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Project deleted successfully', 'success');
    this.loadProjects();
  }

  import = () => this.props.navigate(`setting/import/add?model=${Const.Project}`);
  export = fields => Util.confirmAlert('Export', `Are you sure you want to export to with `
    +` applied filters ? `, 'Export', 'Cancel', () => {
      this.setState({ ...this.state, inApiCall: true });
      ImportExportAPI.exportModel(Const.Project, this.list.filters, this.list.sorting, this.data.projectCount, fields, 
        this.model.model_no, this.onExport, this.props.failure);
  });
  onExport = () => {
    this.setState({ ...this.state, inApiCall: false });
    Util.showNotification('Successful', 'Project Export in progress.'
      + ' Please visit Settings', 'success');
  }
  onMassUpdate = updates => {
    this.setState({ ...this.state, massUpdate: false, inApiCall: true });
    ProjectAPI.massUpdate(this.list, updates, this.onMassUpdated, this.props.failure, this.props.logout);
  }
  onMassUpdated = () => {
    Util.showNotification('Successful', 'Project Mass Updated successfull.', 'success');
    this.loadProjects();
  }

  onTabClick = view => {
    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    cView.project = view;
    reactLocalStorage.setObject(Const.CurrentViews, cView);
    if (this.view.id !== view) {
      this.view = this.views.find((item) => item.id === view);
      this.setList();
      this.loadProjects();
    }
    this.setState({ ...this.state, isFilterOpen: false });
  };

  onSelect = id => {
    this.selected.push(id);
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onRemove = id => {
    this.selected = this.selected.filter(item => id !== item);
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onSelectAll = () => {
    for (let i = 0; i < this.data.projects.length; i++) {
      const id = this.selected.find(item => item === this.data.projects[i].id);
      if (!id) this.selected.push(this.data.projects[i].id);
    }
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onRemoveAll = () => {
    for (let i = 0; i < this.data.projects.length; i++) {
      this.selected = this.selected.filter(item => item !== this.data.projects[i].id);
    }
    this.setState({ ...this.state, selected: !this.state.selected });
  };

  render() {
    if(!this.List) return null;
    return (
      <div>
        { this.state.massUpdate &&
          <MassUpdatePopup models={this.model} onUpdateChanged={this.onUpdateChanged}
            onMassUpdate={this.onMassUpdate} showMassUpdate={this.showMassUpdate} />
        }

        <HeaderViewList
          views={this.views}
          view={this.view}
          onTabClick={this.onTabClick}
        />

        <ListHeader
          model={this.model}
          name={this.model.label_name}
          pagination={this.list.pagination}
          listCount={this.data.projectCount}
          filterCount={this.list.filters.length}
          onPageChange={this.onPageChange}
          perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange}
          toggleFilter={this.toggleFilter}
          onAddClick={() => this.onAddEdit(-1)}
          add={this.Add}
          import={this.import}
          export={this.export}
          update={this.update}
          showMassUpdate={this.showMassUpdate}
        />

        <div className="container-fluid ">
          <div className="row">
            <TableUI
              data={this.data.projects}
              model={this.model}
              fields={this.list.fields}
              order={this.list.sorting}
              pagination={this.list.pagination}
              inApiCall={this.state.inApiCall}
              preview={true}
              update={this.Update}
              delete={this.Delete}
              onAddEdit={this.onAddEdit}
              onPreview={this.onPreview}
              onDelete={this.onDelete}
              onFieldSelection={this.onFieldSelection}
              selected={this.selected} onSelect={this.onSelect} onRemove={this.onRemove}
              onSelectAll={this.onSelectAll} onRemoveAll={this.onRemoveAll}
              onOrderChange={this.onOrderChange}
              isFilterOpen={this.state.isFilterOpen}
            />

            <FilterPannel
              filters={this.list.filters}
              fields={this.model.fields}
              onFilterChange={this.onFilterChange}
              closeFilter={this.closeFilter}
              isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(ProjectList);